import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import ProfileImageUpload from '../../Components/ProfileImageUpload';

const RegisterContainer = styled.div`
 min-height: 100vh;
 background-color: white;
 font-family: 'Noto Sans Thai', sans-serif !important;
 * {
   font-family: 'Noto Sans Thai', sans-serif !important;
 }
`;

const Header = styled.div`
 background: white;
 padding: 16px 24px;
 display: flex;
 align-items: center;
 gap: 12px;
 box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.img`
 width: 32px;
 height: 32px;
 object-fit: contain;
`;

const HeaderTitle = styled.h1`
 font-size: 18px;
 font-weight: bold;
 color: #666;
 margin: 0;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const StepIndicator = styled.div`
 display: flex;
 align-items: center;
 justify-content: center;
 padding: 24px;
 gap: 16px;
`;

const StepCircle = styled.div`
 width: 40px;
 height: 40px;
 border-radius: 50%;
 display: flex;
 align-items: center;
 justify-content: center;
 font-size: 18px;
 font-weight: 600;
 font-family: 'Noto Sans Thai', sans-serif !important;
 
 ${props => props.active ? `
   background-color: #00BBD3;
   color: white;
 ` : `
   background-color: #e1e5e9;
   color: #999;
 `}
`;

const StepLine = styled.div`
 width: 60px;
 height: 4px;
 background-color: #e1e5e9;
 border-radius: 2px;
`;

const Content = styled.div`
 padding: 24px;
 max-width: 400px;
 margin: 0 auto;
`;

const ProfileSection = styled.div`
 display: flex;
 flex-direction: column;
 align-items: center;
 margin-bottom: 32px;
`;

const ProfileImageContainer = styled.div`
 position: relative;
 margin-bottom: 24px;
`;

const ProfileImage = styled.div`
 width: 120px;
 height: 120px;
 border-radius: 50%;
 background-color: #d1d5db;
 display: flex;
 align-items: center;
 justify-content: center;
 position: relative;
`;

const ProfileIcon = styled.div`
 width: 60px;
 height: 60px;
 background-image: url("data:image/svg+xml,%3csvg width='60' height='60' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' fill='%23ffffff'/%3e%3c/svg%3e");
 background-repeat: no-repeat;
 background-position: center;
 background-size: contain;
`;

const EditButton = styled.div`
 position: absolute;
 bottom: 0;
 right: 0;
 width: 36px;
 height: 36px;
 border-radius: 50%;
 background-color: #00BBD3;
 display: flex;
 align-items: center;
 justify-content: center;
 cursor: pointer;
 transition: background-color 0.3s ease;
 
 &:hover {
   background-color: #009bb3;
 }
`;

const EditIcon = styled.div`
 width: 20px;
 height: 20px;
 background-image: url("data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' fill='white'/%3e%3c/svg%3e");
 background-repeat: no-repeat;
 background-position: center;
 background-size: contain;
`;

const SectionTitle = styled.h2`
 font-size: 20px;
 font-weight: 600;
 color: #00BBD3;
 margin-bottom: 24px;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const InfoGrid = styled.div`
 display: grid;
 gap: 16px;
 margin-bottom: 32px;
`;

const InfoRow = styled.div`
 display: flex;
 flex-direction: column;
 align-items: flex-start;
 padding: 12px 0;
 gap: 8px;
`;

const InfoLabel = styled.span`
 font-size: 16px;
 color: #666666;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const InfoValue = styled.span`
 font-size: 16px;
 color: #666;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const FormSection = styled.div`
 margin-bottom: 32px;
`;

const FormRow = styled.div`
 display: flex;
 flex-direction: column;
 align-items: flex-start;
 margin-bottom: 20px;
 gap: 8px;
 width: 100%;
`;

const FormLabel = styled.label`
 font-size: 16px;
 color: #666666;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
 flex: 1;
 text-align: left;
`;

const FormInputContainer = styled.div`
 display: flex;
 align-items: center;
 justify-content: center;
 gap: 8px;
 flex: 2;
`;

const SmallInput = styled.input`
 width: 80px;
 padding: 12px 16px;
 border: 2px solid #e1e5e9;
 border-radius: 12px;
 font-size: 16px;
 color: #666666;
 background-color: white;
 transition: border-color 0.3s ease;
 font-family: 'Noto Sans Thai', sans-serif !important;
 font-weight: bold;
 text-align: center;

 &:focus {
   outline: none;
   border-color: #00BBD3;
 }
`;

const FullInput = styled.input`
 width: 100%;
 padding: 12px 16px;
 border: 2px solid #e1e5e9;
 border-radius: 12px;
 font-size: 16px;
 color: #666666;
 background-color: white;
 transition: border-color 0.3s ease;
 font-family: 'Noto Sans Thai', sans-serif !important;
 font-weight: bold;
 box-sizing: border-box;

 &:focus {
   outline: none;
   border-color: #00BBD3;
 }

 &::placeholder {
   color: #999999;
   font-weight: normal;
 }
`;

const UnitLabel = styled.span`
 font-size: 16px;
 color: #666;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
 width: 80px;
 text-align: left;
`;

const DiseaseSection = styled.div`
 margin-top: 40px;
 margin-bottom: 32px;
`;

const DiseaseTitle = styled.h2`
 font-size: 20px;
 font-weight: 600;
 color: #00BBD3;
 margin-bottom: 16px;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const DiseaseDescription = styled.p`
 font-size: 14px;
 color: #666;
 line-height: 1.5;
 margin-bottom: 24px;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
`;

const RadioRow = styled.div`
 display: flex;
 align-items: center;
 gap: 24px;
 margin-bottom: 20px;
`;

const RadioGroup = styled.div`
 display: flex;
 align-items: center;
 gap: 12px;
 cursor: pointer;
 padding: 12px 16px;
 border-radius: 12px;
 transition: background-color 0.2s ease;
 min-height: 50px;
 
 &:hover {
   background-color: #f0f9ff;
 }
`;

const RadioInput = styled.input.attrs({ type: 'radio' })`
 width: 24px;
 height: 24px;
 border: 3px solid #00BBD3;
 border-radius: 50%;
 background-color: white;
 cursor: pointer;
 appearance: none;
 position: relative;
 transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
 transform: scale(1);
 flex-shrink: 0;
 
 &:hover {
   transform: scale(1.05);
   border-color: #009bb3;
 }
 
 &:checked {
   background-color: #00BBD3;
   transform: scale(1.1);
 }
 
 &:checked::after {
   content: '';
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   width: 10px;
   height: 10px;
   background-color: white;
   border-radius: 50%;
   animation: checkPulse 0.3s ease;
 }
 
 &:active {
   transform: scale(0.95);
 }
`;

const RadioLabel = styled.label`
 font-size: 18px;
 color: #666666;
 cursor: pointer;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
 line-height: 1.4;
 flex: 1;
`;

const SingleRadioGroup = styled.div`
 margin-bottom: 20px;
`;

const CheckboxSection = styled.div`
 margin-left: 24px;
 margin-top: 16px;
 max-height: ${props => props.show ? '600px' : '0'};
 overflow: hidden;
 opacity: ${props => props.show ? '1' : '0'};
 transform: translateY(${props => props.show ? '0' : '-10px'});
 transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
`;

const CheckboxRow = styled.div`
 display: flex;
 align-items: center;
 gap: 12px;
 margin-bottom: 16px;
 transform: translateX(0);
 transition: transform 0.2s ease, opacity 0.2s ease, background-color 0.2s ease;
 padding: 12px 16px;
 border-radius: 12px;
 cursor: pointer;
 min-height: 50px;
 
 &:hover {
   transform: translateX(4px);
   background-color: #f0f9ff;
 }
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
 width: 24px;
 height: 24px;
 border: 3px solid #00BBD3;
 border-radius: 6px;
 background-color: white;
 cursor: pointer;
 appearance: none;
 transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
 transform: scale(1);
 flex-shrink: 0;
 
 &:hover {
   transform: scale(1.05);
   border-color: #009bb3;
 }
 
 &:checked {
   background-color: #00BBD3;
   background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m13.854 3.646-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 9.293l6.646-6.647a.5.5 0 0 1 .708.708z'/%3e%3c/svg%3e");
   background-size: 14px;
   background-position: center;
   background-repeat: no-repeat;
   transform: scale(1.1);
 }
 
 &:active {
   transform: scale(0.95);
 }
`;

const CheckboxLabel = styled.label`
 font-size: 18px;
 color: #666666;
 cursor: pointer;
 font-weight: bold;
 font-family: 'Noto Sans Thai', sans-serif !important;
 line-height: 1.4;
 flex: 1;
`;

const DropdownContainer = styled.div`
 margin-left: 32px;
 margin-top: 8px;
 max-height: ${props => props.show ? '60px' : '0'};
 overflow: hidden;
 opacity: ${props => props.show ? '1' : '0'};
 transform: translateY(${props => props.show ? '0' : '-5px'});
 transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

const Dropdown = styled.select`
 width: 200px;
 padding: 12px 16px;
 border: 2px solid #e1e5e9;
 border-radius: 12px;
 font-size: 16px;
 color: #666666;
 background-color: white;
 transition: border-color 0.3s ease;
 font-family: 'Noto Sans Thai', sans-serif !important;
 font-weight: bold;
 cursor: pointer;

 &:focus {
   outline: none;
   border-color: #00BBD3;
 }
`;

const InlineFormRow = styled.div`
 display: flex;
 align-items: center;
 justify-content: space-between;
 margin-bottom: 20px;
 width: 100%;
`;

const NextButton = styled.button`
 background-color: #00BBD3;
 color: white;
 border: none;
 border-radius: 30px;
 padding: 18px 32px;
 font-size: 18px;
 font-weight: bold;
 cursor: pointer;
 transition: all 0.3s ease;
 width: 100%;
 font-family: 'Noto Sans Thai', sans-serif !important;
 box-shadow: 0 9px 14px 0 rgba(0, 187, 211, 0.08);

 &:hover {
   background-color: #009bb3;
 }

 &:active {
   background-color: #008aa0;
 }
`;

const CheckPulse = `
 @keyframes checkPulse {
   0% {
     transform: translate(-50%, -50%) scale(0);
     opacity: 0;
   }
   50% {
     transform: translate(-50%, -50%) scale(1.2);
     opacity: 0.8;
   }
   100% {
     transform: translate(-50%, -50%) scale(1);
     opacity: 1;
   }
 }
`;

const GlobalStyles = `
 ${CheckPulse}
`;

const RegisterStep1 = () => {
 const navigate = useNavigate();
 

 const [formData, setFormData] = useState({
   idCard: '',
   phone: '',
   firstName: '',
   lastName: '',
   gender: '',
   birthDay: '',
   birthMonth: '',
   birthYear: '',
   height: '',
   weight: '',
   waist: '',
   profileImage: null
 });

 const [diseaseData, setDiseaseData] = useState({
   consent: '',
   hasDisease: '',
   diseases: {
     diabetes: false,
     diabetesType: '',
     hypertension: false,
     kidneyDisease: false,
     hyperlipidemia: false,
     heartDisease: false,
     stroke: false,
     thyroid: false,
     emphysema: false
   }
 });

 useEffect(() => {
   const savedFormData = localStorage.getItem('register_step1_formData');
   const savedDiseaseData = localStorage.getItem('register_step1_diseaseData');
   
   if (savedFormData) {
     setFormData(JSON.parse(savedFormData));
   }
   
   if (savedDiseaseData) {
     setDiseaseData(JSON.parse(savedDiseaseData));
   }
 }, []);

 useEffect(() => {
   localStorage.setItem('register_step1_formData', JSON.stringify(formData));
 }, [formData]);

 useEffect(() => {
   localStorage.setItem('register_step1_diseaseData', JSON.stringify(diseaseData));
 }, [diseaseData]);

 const handleInputChange = (field, value) => {
   setFormData(prev => ({
     ...prev,
     [field]: value
   }));
 };

 const handleDiseaseChange = (field, value) => {
   setDiseaseData(prev => ({
     ...prev,
     [field]: value
   }));
 };

 const handleDiseaseCheckbox = (disease, checked) => {
   setDiseaseData(prev => ({
     ...prev,
     diseases: {
       ...prev.diseases,
       [disease]: checked,
       ...(disease === 'diabetes' && !checked && { diabetesType: '' })
     }
   }));
 };

 const handleDiabetesType = (type) => {
   setDiseaseData(prev => ({
     ...prev,
     diseases: {
       ...prev.diseases,
       diabetesType: type
     }
   }));
 };

 const handleRadioGroupClick = (name, value) => {
   handleDiseaseChange(name, value);
 };

 const handleCheckboxRowClick = (disease) => {
   handleDiseaseCheckbox(disease, !diseaseData.diseases[disease]);
 };

 const handleNext = () => {
   if (!formData.idCard || !formData.phone || !formData.firstName || !formData.lastName || !formData.gender || !formData.birthDay || !formData.birthMonth || !formData.birthYear) {
     alert('กรุณากรอกข้อมูลส่วนตัวให้ครบถ้วน');
     return;
   }

   // ตรวจสอบความยาวเลขบัตรประชาชน
   if (formData.idCard.length !== 13) {
     alert('กรุณากรอกเลขบัตรประชาชนให้ครบ 13 หลัก');
     return;
   }

   // ตรวจสอบความยาวเบอร์มือถือ
   if (formData.phone.length !== 10) {
     alert('กรุณากรอกเบอร์มือถือให้ครบ 10 หลัก');
     return;
   }

   if (!formData.height || !formData.weight || !formData.waist) {
     alert('กรุณากรอกข้อมูลร่างกายให้ครบถ้วน');
     return;
   }

   if (!diseaseData.consent) {
     alert('กรุณาเลือกยินยอมหรือไม่ยินยอมในการเก็บข้อมูลโรคประจำตัว');
     return;
   }

   if (diseaseData.consent === 'yes' && !diseaseData.hasDisease) {
     alert('กรุณาระบุว่ามีโรคประจำตัวหรือไม่');
     return;
   }

   const registrationData = {
     formData,
     diseaseData,
     timestamp: new Date().toISOString()
   };

   // บันทึกข้อมูลรวม
   localStorage.setItem('register_complete_data', JSON.stringify(registrationData));

   // บันทึกเฉพาะ formData และ diseaseData สำหรับ step2 ใช้งาน
   localStorage.setItem('registerStep1Data', JSON.stringify(formData));
   localStorage.setItem('registerStep1DiseaseData', JSON.stringify(diseaseData));

   navigate('/register/step2', { state: { step1Data: formData, diseaseData } });
 };

 const handleProfileImageChange = (imageUrl) => {
   setFormData(prev => ({
     ...prev,
     profileImage: imageUrl
   }));
 };

 return (
   <>
     <style>{GlobalStyles}</style>
     <RegisterContainer>
       <Header>
         <Logo src="/logo.png" alt="MFU Logo" />
         <HeaderTitle>MFU Wellness Center</HeaderTitle>
       </Header>

       <StepIndicator>
         <StepCircle active>1</StepCircle>
         <StepLine />
         <StepCircle>2</StepCircle>
       </StepIndicator>

       <Content>
         <ProfileSection>
           <ProfileImageUpload
             imageUrl={formData.profileImage}
             onImageChange={handleProfileImageChange}
             userId={formData.idCard || 'temp'}
             disabled={false}
           />
         </ProfileSection>

         <SectionTitle>ข้อมูลส่วนตัว</SectionTitle>
         
         <FormSection>
          <FormRow>
            <FormLabel>เลขบัตรประชาชน</FormLabel>
            <FullInput
              type="text"
              value={formData.idCard}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ''); // รับเฉพาะตัวเลข
                if (value.length <= 13) {
                  handleInputChange('idCard', value);
                }
              }}
              placeholder="เลข 13 หลัก"
              maxLength={13}
            />
          </FormRow>
          <FormRow>
            <FormLabel>เบอร์มือถือ</FormLabel>
            <FullInput
              type="tel"
              value={formData.phone}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ''); // รับเฉพาะตัวเลข
                if (value.length <= 10) {
                  handleInputChange('phone', value);
                }
              }}
              placeholder="0812345678 (10 หลัก)"
              maxLength={10}
            />
          </FormRow>
          <FormRow>
            <FormLabel>ชื่อ</FormLabel>
            <FullInput
              type="text"
              value={formData.firstName}
              onChange={(e) => handleInputChange('firstName', e.target.value)}
              placeholder="กรอกชื่อ"
            />
          </FormRow>
          <FormRow>
            <FormLabel>นามสกุล</FormLabel>
            <FullInput
              type="text"
              value={formData.lastName}
              onChange={(e) => handleInputChange('lastName', e.target.value)}
              placeholder="กรอกนามสกุล"
            />
          </FormRow>
          <InlineFormRow>
            <FormLabel>เพศ</FormLabel>
            <div style={{display: 'flex', gap: '20px'}}>
              <RadioGroup onClick={() => handleInputChange('gender', 'male')}>
                <RadioInput
                  name="gender"
                  value="male"
                  checked={formData.gender === 'male'}
                  onChange={(e) => handleInputChange('gender', e.target.value)}
                />
                <RadioLabel>ชาย</RadioLabel>
              </RadioGroup>
              <RadioGroup onClick={() => handleInputChange('gender', 'female')}>
                <RadioInput
                  name="gender"
                  value="female"
                  checked={formData.gender === 'female'}
                  onChange={(e) => handleInputChange('gender', e.target.value)}
                />
                <RadioLabel>หญิง</RadioLabel>
              </RadioGroup>
            </div>
          </InlineFormRow>
          <FormRow>
            <FormLabel>วันเดือนปีเกิด</FormLabel>
            <div style={{display: 'flex', gap: '8px', width: '100%'}}>
              <Dropdown
                value={formData.birthDay}
                onChange={(e) => handleInputChange('birthDay', e.target.value)}
                style={{flex: '1'}}
              >
                <option value="">วัน</option>
                {Array.from({length: 31}, (_, i) => (
                  <option key={i + 1} value={i + 1}>{i + 1}</option>
                ))}
              </Dropdown>
              <Dropdown
                value={formData.birthMonth}
                onChange={(e) => handleInputChange('birthMonth', e.target.value)}
                style={{flex: '2'}}
              >
                <option value="">เดือน</option>
                <option value="1">มกราคม</option>
                <option value="2">กุมภาพันธ์</option>
                <option value="3">มีนาคม</option>
                <option value="4">เมษายน</option>
                <option value="5">พฤษภาคม</option>
                <option value="6">มิถุนายน</option>
                <option value="7">กรกฎาคม</option>
                <option value="8">สิงหาคม</option>
                <option value="9">กันยายน</option>
                <option value="10">ตุลาคม</option>
                <option value="11">พฤศจิกายน</option>
                <option value="12">ธันวาคม</option>
              </Dropdown>
              <Dropdown
                value={formData.birthYear}
                onChange={(e) => handleInputChange('birthYear', e.target.value)}
                style={{flex: '1'}}
              >
                <option value="">ปี</option>
                {Array.from({length: 80}, (_, i) => {
                  const year = 2024 - i;
                  return (
                    <option key={year} value={year}>{year + 543}</option>
                  );
                })}
              </Dropdown>
            </div>
          </FormRow>
        </FormSection>

         <FormSection>
           <InlineFormRow>
             <FormLabel>ส่วนสูง</FormLabel>
             <FormInputContainer>
               <SmallInput
                 type="number"
                 value={formData.height}
                 onChange={(e) => handleInputChange('height', e.target.value)}
               />
               <UnitLabel>เซนติเมตร</UnitLabel>
             </FormInputContainer>
           </InlineFormRow>

           <InlineFormRow>
             <FormLabel>น้ำหนัก</FormLabel>
             <FormInputContainer>
               <SmallInput
                 type="number"
                 value={formData.weight}
                 onChange={(e) => handleInputChange('weight', e.target.value)}
               />
               <UnitLabel>กิโลกรัม</UnitLabel>
             </FormInputContainer>
           </InlineFormRow>

           <InlineFormRow>
             <FormLabel>วัดรอบเอว</FormLabel>
             <FormInputContainer>
               <SmallInput
                 type="number"
                 value={formData.waist}
                 onChange={(e) => handleInputChange('waist', e.target.value)}
               />
               <UnitLabel>(นิ้ว)</UnitLabel>
             </FormInputContainer>
           </InlineFormRow>
         </FormSection>

         <DiseaseSection>
           <DiseaseTitle>โรคประจำตัว (ถ้ามี)</DiseaseTitle>
           <DiseaseDescription>
             เราเก็บข้อมูลโรคประจำตัวของคุณเพื่อใช้ในการจัดทำคำแนะนำที่เหมาะสมกับการดูแลสุขภาพของคุณ หากคุณประสงค์จะให้ข้อมูลกรุณากด ยินยอม
           </DiseaseDescription>

           <RadioRow>
             <RadioGroup onClick={() => handleRadioGroupClick('consent', 'yes')}>
               <RadioInput
                 name="consent"
                 value="yes"
                 checked={diseaseData.consent === 'yes'}
                 onChange={(e) => handleDiseaseChange('consent', e.target.value)}
               />
               <RadioLabel>ยินยอม</RadioLabel>
             </RadioGroup>
             <RadioGroup onClick={() => handleRadioGroupClick('consent', 'no')}>
               <RadioInput
                 name="consent"
                 value="no"
                 checked={diseaseData.consent === 'no'}
                 onChange={(e) => handleDiseaseChange('consent', e.target.value)}
               />
               <RadioLabel>ไม่ยินยอม</RadioLabel>
             </RadioGroup>
           </RadioRow>

           {diseaseData.consent === 'yes' && (
             <>
               <SingleRadioGroup>
                 <RadioGroup onClick={() => handleRadioGroupClick('hasDisease', 'no')}>
                   <RadioInput
                     name="hasDisease"
                     value="no"
                     checked={diseaseData.hasDisease === 'no'}
                     onChange={(e) => handleDiseaseChange('hasDisease', e.target.value)}
                   />
                   <RadioLabel>ไม่มีโรคประจำตัว</RadioLabel>
                 </RadioGroup>
               </SingleRadioGroup>

               <SingleRadioGroup>
                 <RadioGroup onClick={() => handleRadioGroupClick('hasDisease', 'yes')}>
                   <RadioInput
                     name="hasDisease"
                     value="yes"
                     checked={diseaseData.hasDisease === 'yes'}
                     onChange={(e) => handleDiseaseChange('hasDisease', e.target.value)}
                   />
                   <RadioLabel>มีโรคประจำตัว ระบุได้หลายโรค</RadioLabel>
                 </RadioGroup>

                 <CheckboxSection show={diseaseData.hasDisease === 'yes'}>
                   <CheckboxRow onClick={() => handleCheckboxRowClick('diabetes')}>
                     <Checkbox
                       checked={diseaseData.diseases.diabetes}
                       onChange={(e) => handleDiseaseCheckbox('diabetes', e.target.checked)}
                     />
                     <CheckboxLabel>เบาหวาน ชนิด</CheckboxLabel>
                   </CheckboxRow>
                   <DropdownContainer show={diseaseData.diseases.diabetes}>
                     <Dropdown
                       value={diseaseData.diseases.diabetesType}
                       onChange={(e) => handleDiabetesType(e.target.value)}
                     >
                       <option value="">โรคเบาหวานชนิดที่ 1</option>
                       <option value="type1">โรคเบาหวานชนิดที่ 1</option>
                       <option value="type2">โรคเบาหวานชนิดที่ 2</option>
                     </Dropdown>
                   </DropdownContainer>

                   <CheckboxRow onClick={() => handleCheckboxRowClick('hypertension')}>
                     <Checkbox
                       checked={diseaseData.diseases.hypertension}
                       onChange={(e) => handleDiseaseCheckbox('hypertension', e.target.checked)}
                     />
                     <CheckboxLabel>ความดันโลหิตสูง</CheckboxLabel>
                   </CheckboxRow>

                   <CheckboxRow onClick={() => handleCheckboxRowClick('kidneyDisease')}>
                     <Checkbox
                       checked={diseaseData.diseases.kidneyDisease}
                       onChange={(e) => handleDiseaseCheckbox('kidneyDisease', e.target.checked)}
                     />
                     <CheckboxLabel>โรคไตเรื้อรัง</CheckboxLabel>
                   </CheckboxRow>

                   <CheckboxRow onClick={() => handleCheckboxRowClick('hyperlipidemia')}>
                     <Checkbox
                       checked={diseaseData.diseases.hyperlipidemia}
                       onChange={(e) => handleDiseaseCheckbox('hyperlipidemia', e.target.checked)}
                     />
                     <CheckboxLabel>ไขมันในเลือดสูง</CheckboxLabel>
                   </CheckboxRow>

                   <CheckboxRow onClick={() => handleCheckboxRowClick('heartDisease')}>
                     <Checkbox
                       checked={diseaseData.diseases.heartDisease}
                       onChange={(e) => handleDiseaseCheckbox('heartDisease', e.target.checked)}
                     />
                     <CheckboxLabel>หัวใจ</CheckboxLabel>
                   </CheckboxRow>

                   <CheckboxRow onClick={() => handleCheckboxRowClick('stroke')}>
                     <Checkbox
                       checked={diseaseData.diseases.stroke}
                       onChange={(e) => handleDiseaseCheckbox('stroke', e.target.checked)}
                     />
                     <CheckboxLabel>หลอดเลือดสมอง</CheckboxLabel>
                   </CheckboxRow>

                   <CheckboxRow onClick={() => handleCheckboxRowClick('thyroid')}>
                     <Checkbox
                       checked={diseaseData.diseases.thyroid}
                       onChange={(e) => handleDiseaseCheckbox('thyroid', e.target.checked)}
                     />
                     <CheckboxLabel>ไทรอยด์</CheckboxLabel>
                   </CheckboxRow>

                   <CheckboxRow onClick={() => handleCheckboxRowClick('emphysema')}>
                     <Checkbox
                       checked={diseaseData.diseases.emphysema}
                       onChange={(e) => handleDiseaseCheckbox('emphysema', e.target.checked)}
                     />
                     <CheckboxLabel>ถุงลมโป่งพอง</CheckboxLabel>
                   </CheckboxRow>
                 </CheckboxSection>
               </SingleRadioGroup>
             </>
           )}
         </DiseaseSection>

         <NextButton onClick={handleNext}>
           ถัดไป
         </NextButton>
       </Content>
     </RegisterContainer>
   </>
 );
};

export default RegisterStep1;